export function buildButtonAttributes(configuration) {

  const attributes = {
    type: 'button',
    class: 'delete-button'
  };

  if (typeof configuration.id === 'string') {
    attributes.id = configuration.id;
  }

  return attributes;

}